import React, {FC} from 'react';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';

export const RuleExpressionAtomSeparator: FC = () => <Icon name="arrowDownThickSmall" />;
